import React, { Component } from 'react';
import { observer } from 'mobx-react';

import styled from 'styled-components';

/* eslint-disable react/prop-types */

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

@observer
export default class LayoutWrapper extends Component {
  render() {
    const {
      children,
    } = this.props;

    return (
      <Wrapper>
        {children}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/Layout/LayoutWrapper.jsx